var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CreateTrackingCategoryAmountPopup',{attrs:{"closeAction":_vm.close},on:{"close":_vm.onSave}}),_vm._v(" "),_c('separator'),_vm._v(" "),_c('div',{staticClass:"footer-btn",on:{"click":_vm.doNotShowAgain}},[_vm._v("הבנתי, אל תציגו לי יותר")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }